import { useMutation, useQueryClient } from '@tanstack/react-query';
import { PasskeysQueryKeys } from '../../queryKey';
import { fetchDeletePassKey } from './service';

export function useDeletePassKey() {
  const queryClient = useQueryClient();

  function onSuccess() {
    queryClient.invalidateQueries({ queryKey: [PasskeysQueryKeys.Passkey] });
  }
  const { mutate, isPending, isError } = useMutation({
    mutationFn: fetchDeletePassKey,
    onSuccess,
  });

  return {
    deletePassKey: mutate,
    loadingDeletePassKey: isPending,
    isError,
  };
}
